import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Supported languages - Covering Top 10 Dog-Owning Countries
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸', nativeName: 'English' },          // USA, UK
  { code: 'zh', name: 'Chinese', flag: '🇨🇳', nativeName: '中文' },              // China (#2)
  { code: 'ru', name: 'Russian', flag: '🇷🇺', nativeName: 'Русский' },          // Russia (#3)
  { code: 'ja', name: 'Japanese', flag: '🇯🇵', nativeName: '日本語' },          // Japan (#5)
  { code: 'tl', name: 'Filipino', flag: '🇵🇭', nativeName: 'Tagalog' },         // Philippines (#6)
  { code: 'de', name: 'German', flag: '🇩🇪', nativeName: 'Deutsch' },           // Germany (#7)
  { code: 'hi', name: 'Hindi', flag: '🇮🇳', nativeName: 'हिन्दी' },              // India (#8)
  { code: 'es', name: 'Spanish', flag: '🇪🇸', nativeName: 'Español' },          // Spain (#9), Argentina (#10)
  { code: 'fr', name: 'French', flag: '🇫🇷', nativeName: 'Français' },          // France (#13)
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹', nativeName: 'Português' },     // Portugal, Brazil
];

i18n
  .use(HttpBackend) // Load translations from /public/locales
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass to React
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map(l => l.code),
    
    // Detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'vbb_language'
    },
    
    // Backend options
    backend: {
      loadPath: '/locales/{{lng}}/translation.json'
    },
    
    interpolation: {
      escapeValue: false // React already does escaping
    },
    
    // Debug mode (disable in production)
    debug: false,
    
    // React options
    react: {
      useSuspense: true
    }
  });

export default i18n;
